import React from 'react';
import {Divider, Stack} from "@mui/material";
import ListOfChats from "../../../components/chat/list/ListOfChats";
import ChatBody from "../../../components/chat/body/ChatBody";
import ProductPreviewSection from "../../../components/ProductPreview/ProductPreviewSection";

const ChatPage = () => {

    return (
        <Stack overflow={'hidden'} flex={1}>
            <Stack
                direction={'row'}
                overflow={'hidden'}
                flex={1}
            >

                <Stack
                    width={'20%'}
                    bgcolor={'white'}
                    overflow={'auto'}
                >
                    <ListOfChats/>
                </Stack>

                <Divider orientation={'vertical'}/>

                <Stack
                    width={'40%'}
                    bgcolor={'white'}

                    overflow={'auto'}
                >
                    {/*{chatId ? <ChatBody/> : <Outlet/>}*/}
                    <ChatBody/>
                </Stack>


                <Divider orientation={'vertical'}/>


                <Stack
                    width={'40%'}
                    bgcolor={'white'}
                    overflow={'auto'}
                >
                    <ProductPreviewSection/>
                </Stack>

            </Stack>
        </Stack>
    );
};

export default ChatPage;